import type { HttpErrorResponse } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpXhrBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { firstValueFrom } from 'rxjs';

import { HTTP_STATUS } from '../http-status';
import { AuthorisationStrategy } from './authorization-strategy.interface';
import { HttpApiService } from './http-api.service';

@Injectable({ providedIn: 'root' })
export class GenericAuthService<AccessTokenResponse, CurrentUserResponse> {
  private http: HttpClient;

  constructor(private authorisationStrategy: AuthorisationStrategy) {
    this.http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
  }

  public async fetchUser(authToken: string, currentUserUrl: string) {
    const httpOptions = {
      headers: this.getAuthorizedUserHeaders(authToken),
    };

    try {
      return await firstValueFrom(
        <Observable<CurrentUserResponse>>this.http.get(currentUserUrl, httpOptions),
      );
    } catch (error) {
      // this.onResponseError(error);
      return Promise.reject(error);
    }
  }

  public fetchAccessToken(authTokenUrl: string): Promise<AccessTokenResponse | HttpErrorResponse> {
    return <Promise<AccessTokenResponse>>firstValueFrom(
      this.http.get(authTokenUrl, {
        withCredentials: true,
        headers: HttpApiService.defaultHeaders,
      }),
    ).catch((data: HttpErrorResponse) => this.onResponseError(data));
  }

  private onResponseError(response: HttpErrorResponse): HttpErrorResponse {
    const { ok, status } = response;

    if (
      (!ok && status === HTTP_STATUS.UNAUTHORIZED) ||
      status === HTTP_STATUS.UNPROCESSABLE_ENTITY
    ) {
      this.authorisationStrategy.onAuthorizationFailed(response);
    }

    return response;
  }

  private getAuthorizedUserHeaders(authToken: string): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${authToken}`,
      ...HttpApiService.defaultHeaders,
    });
  }
}
